<form>
    <div class="buscador">
        <plex-text [(ngModel)]="searchTerm" name="searchTerm" [debounce]="600" (change)="buscar()" placeholder="Buscar ..." [autoFocus]="autofocus"></plex-text>
        <plex-loader  *ngIf="loading" type="linear"></plex-loader>
    </div>
</form>
